import { formatRepoFiltersToApiFilters } from '@webapp/core/utils/repositories/formatRepoFiltersToApiFilters'
import { type RepoFilterParams } from '@webapp/infrastructure/interfaces/repositories/RepoFilterParams'
import { type RepoPaginatedResponse } from '@webapp/infrastructure/interfaces/repositories/RepoPaginatedResponse'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type IAuditLogRepository } from '../../business-logic/interfaces/IAuditLogRepository'
import { type AuditLogRecordConstructorData } from '../../entities/AuditLogRecord'
import { mapAuditLogRecordApiModel } from '../mappers/mapAuditLogRecordApiModel'
import { type GetAuditLogResponse } from '../types/GetAuditLogResponse'

interface Dependency {
  httpClient: IHttpClient
}

export class AuditLogRepository implements IAuditLogRepository {
  constructor(private readonly deps: Dependency) {}

  async getAuditLog(
    contentTypeId: number,
    objectId: string,
    params?: RepoFilterParams
  ): Promise<RepoPaginatedResponse<AuditLogRecordConstructorData>> {
    const res = await this.deps.httpClient.get<GetAuditLogResponse>(
      `/api/v3/audit/${contentTypeId}/${objectId}/`,
      {
        params: {
          ...formatRepoFiltersToApiFilters(params),
        },
      }
    )

    const auditLog = res.data.data
    const metadata = res.data.metadata

    return {
      data: auditLog.map((auditLogRecord) =>
        mapAuditLogRecordApiModel(auditLogRecord)
      ),
      pagination: {
        count: metadata?.pagination?.count || 0,
        page: metadata?.pagination?.current_page || 0,
        pageSize: metadata?.pagination?.page_size || 0,
        numPages: metadata?.pagination?.num_pages || 0,
      },
    }
  }
}
